import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />

        <div className="bg-background-100">
          <TopicsSection />
        </div>

        <CarouselSection />

        <div className="bg-background-100">
          <AppSection />
        </div>

        <UpdatesSection />

        <div className="bg-background-100">
          <RankingSection />
        </div>

        <FeaturesSection />

        <div className="bg-background-100">
          <MediaSection />
        </div>

        <CardsSection />

        <div className="bg-background-100">
          <AboutSection />
        </div>

        <FaqSection />

        <div className="bg-background-100">
          <IndexSection />
        </div>

        <ContactSection />

        <div className="bg-background-100">
          <CommentsSection />
        </div>
      </main>
      <Footer />
    </div>
  );
}